import React from 'react'
import { Box, Grid, Typography, Container, Paper } from "@mui/material";
import imgUrl from "../../assets/images/imgUrl";



const highlights = [
  {
    title: "Contribution",
    description: <>
      Share your <i><b>Casts, Videos,<br></br> Songs, Sayings, Stickers, <br></br> Blogs, Stories </b> <br></br> 
      </i>  as part of the Global <br></br> <b><i> I Am Peacekeeper Movement. </i></b> 
    </>,

    colorClass: "gradient-blue",
    image: imgUrl.contriIcon,
  },
  {
    title: "Eligibility",
    description: <>
      Every <b> I Am Peacekeeper </b> who has pledged the 7 Human Values — <b><i> Gratitude, 
      Forgiveness, Love, Humility, Giving, Patience and Truth</i> </b>  — is welcome to contribute. 
    </>,
    colorClass: "gradient-yellow",
    image: imgUrl.eligibilityIcon,
  },
  {
    title: "Goal",
    description: <>
      To make creative expression the living heartbeat of a <b><i>Global Movement</i>  </b>  for <b> <i>Justice, Love & Peace.</i>  </b>
    </>,
    colorClass: "gradient-blue",
    image: imgUrl.goalIcon,
  },
  {
    title: "Global reach",
    description: <>
        Submissions are featured across official <b>I Am Peacekeeper</b>  platforms and carried across the globe, bringing voices from every continent into one harmony.
    </>,
    colorClass: "gradient-yellow",
    image: imgUrl.goalReachIcon,
  },
];

const whyItMatters = [
  <>
     <b>Casts </b>   <br></br> Short spoken reflections  where members share on  he <b><i>28 Gems of World Peace. </i> </b>       Each Cast becomes a voice from the   soul, 
      adding light to a collective archive of compassion and purpose.  
  </>,
  <>
 <b> Videos </b> <br></br> Visual accounts that highlight <br></br> lived values such as <br></br> <i> Freedom, Respect, <br></br>
 Human Rights</i>, showing peace <br></br> in daily life. 
  </>,

  <>
  <b>Songs </b>    <br></br>Melodies that carry <br></br> <i>Unity, Co-existence, Love,</i>  <br></br> building harmony across <br></br> cultures and generations. 
  </>,
  <>
    <b>Sayings </b>  <br></br> Words of wisdom that <br></br> reflect <i> Justice, Integrity, <br></br> Conscience, Truth, <br></br></i> resonating 
      with the <br></br> I Am Peacekeeper <br></br> Charter: Love Letter <br></br> to Humanity. 
  </>,
  <>
  <b>Stickers   </b>  <br></br>Designed emblems symbolising  <br></br>Gratitude, Humility, <br></br> Giving, spreading <br></br> kindness in joyful ways. 
  </>,
  <>
  <b>Blogs </b>   <br></br> Written reflections offering <br></br> perspectives on Forgiveness, <br></br> Patience, Calmness, <br></br>
  Co-creation, weaving peace into <br></br> daily experience.
  </>,
  <>
 <b>Stories </b>  <br></br> Narratives of transformation <br></br> highlighting Inclusivity, Courage, <br></br>
 Values-based Education, <br></br> demonstrating Justice, <br></br> Love & Peace in action. 
  </>
];

const howITWorks = [
  <>
    A <b> Cast</b>  reflecting on Gratitude, Forgiveness, Love. 
  </>,
  <>
  A <b>Video </b> that captures Respect in action or shows Responsibility in daily life.
  </>,

  <>
  A <b>Song </b> celebrating Unity, Co-existence, Hope within your community. 
  </>,
  <>
  A <b>Saying   </b>  that embodies Justice, Integrity, Conscience, Truth.
  </>,
  <>
 <b>Stickers </b>  symbolising Humility, Giving, Compassion through simple design.
  </>,
  <>
 A <b> Blog </b> describing how Responsibility, Fairness, Peace are lived day to day.
  </>,
  <>
  A  <b>Story </b>  of reconciliation shaped by Patience, Calmness, Courage.
  </>,
  <>
   A <b>Video</b>  where youth showcase qualities such as Communication, Co-creation, Leadership.
  </>,
  <>
   A family <b>Story</b>  honouring Freedom, Dignity, Human Rights.

 
  </>,
  <>
   A  <b> Blog </b> reflecting on Values-based Education, growth, personal service.

 
  </>,

  <>
    A <b> Song </b> that turns Compassion, Unity, Love into melody.
  </>,
  <>
    A legacy <b>Cast, Video, Blog, Story </b>  preserved to inspire generations to come.
  </>

];

const circleCourses = [
  {
    text: (
      <>
        Every <b><i> Cast, Video, Song, Saying, Sticker, Blog, Story</i></b> enriches our <b> Global</b> archive of
        <b> <i>Justice, Love & Peace.</i> </b> 
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
        Each contribution adds strength to one collective voice across the globe. 
      </>
    ),
    colorClass: "gradient-yellow",
  },
   {
    text: (
      <>
      Anchored in the <b><i> 7 Human Values </i></b>  and guided by the timeless spirit of the <b> Gems</b>, 
    <b><i> I Am Peacekeeper Voices</i> </b>  safeguards today’s creativity for tomorrow’s world.
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
       Share your voice today — your legacy strengthens the <b> Global <i>I Am Peacekeeper Movement.</i>  </b>
      </>
    ),
    colorClass: "gradient-yellow",
  }
];

const InfoCard = ({ text }) => (
  <Paper elevation={3} className="infoCard">
    <Typography variant="body2" sx={{ fontFamily: 'var(--primary-font)', fontWeight: 400 }}>{text}</Typography>
  </Paper>
);

const ProgramCard = ({ text }) => (
  <Paper elevation={3} className="CircleCard">
    <Typography variant="body2" sx={{ fontFamily: 'var(--primary-font)', fontWeight: 400 }}>{text}</Typography>
  </Paper>
);

const ConclusionCard = ({ text, colorClass }) => (
  <Paper
    elevation={3}
    className={`programCard gradientTrioCards gradientTrioBigCards ${colorClass}`}
    sx={{
      width: 140,
      height: 140,
      borderRadius: "50%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: 2,
      m: "auto",
    }}
  >
    <Typography variant="body2" sx={{ fontFamily: 'var(--primary-font)', fontWeight: 400 }}>{text}</Typography>
  </Paper>
);

const CircleBox = ({
  title,
  description,
  colorClass = "gradient-green",
  image,
}) => (
  <Box
    className={`circleBox ${colorClass}`}
    sx={{
      width: 180,
      height: 180,
      borderRadius: "50%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: 4,
      m: "auto",
    }}
  >
    <img
      src={image || imgUrl.defaultIcon}
      alt={`${title} icon`}
      style={{ width: 40, height: 40, marginBottom: 1 }}
    />
    <Typography variant="subtitle1" fontWeight="bold">
      {title}
    </Typography>
    <Typography variant="body2" sx={{ fontSize: "0.8rem" }}>
      {description}
    </Typography>
  </Box>
);

const BlockCard = ({  title,
  description,
  colorClass = "gradient-green",
  image, }) => (
  <Paper elevation={3} className="infoCard">
     <img
      src={image || imgUrl.defaultIcon}
      alt={`${title} icon`}
      style={{ width: 40, height: 40, marginBottom: 1 }}
    />
    <Typography variant="" fontWeight="bold">
      {title}
    </Typography>
    <Typography variant="body2" sx={{ fontSize: "0.8rem", fontFamily: 'var(--primary-font)', fontWeight: 400 }}>
      {description}
    </Typography>
  </Paper>
);

const Voices = () => {
  return (
    <>
          {/* Influencer Hero Background Section */}
      <Box
        className="programMediaSectionBg commonBannerBg"
        sx={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
          px: 2,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 80,
            left: 0,
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={imgUrl.doveImg}
            alt="Peace Dove Logo"
            sx={{ maxWidth: 200, height: "auto", mr: 1 }}
          />
        </Box>
      </Box>

      {/* Influencer Main Section */}
      <Box className="" mt={5}>
          <Grid container direction="column" alignItems="center" spacing={2}>
            <Grid size={12} display="flex" alignItems="center" justifyContent="center" flexDirection="column">
              <img src={imgUrl.peaceIcon} className="w-100 peaceImg"></img>
              <Typography variant="h1" className="founder-title mainHeading green-title" sx={{ fontFamily: 'var(--heading-font)', fontWeight: 400 }}>
                <i>I Am Peacekeeper  </i>  Voices <br></br>

              </Typography>
            </Grid>

          </Grid>

        </Box>  

         {/* Top Section UI */}
       <Box className="schoolProgramMainSection topBlockBox topBigBlockBox"  mt={5} >
               {/* <Typography
                          variant="h5"
                          align="center"
                          fontWeight="bold"
                          gutterBottom
                          className="subHeading"
                          pt={5}
                        >
                         TOP
                        </Typography> */}
                  <Container className="paddingSubContainer">
                           <Grid container spacing={1} mt={5} mb={2} justifyContent="center">
                             {highlights.map((item, index) => (
                                <Grid size={{xs: 12, md: 3, sm: 6  }} key={index}>
                                                  <BlockCard title={item.title}
                                   description={item.description}
                                   colorClass={item.colorClass}
                                   image={item.image} 
                                                   />
                                                </Grid>
                             ))}
                           </Grid>
                         </Container>
              </Box>

              {/* why it matters */}
                <Box mt={5} className="programCardMain corporateMainSection mattersBigCircle mt-50px">
                                <Typography
                                  variant="h2"
                                  align="center"
                                  fontWeight={400}
                                  gutterBottom
                                  className="subHeading mb-0px"
                                  sx={{ fontFamily: 'var(--heading-font)' }}
                                >
                                  Why It Matters
                                </Typography>
                                {/* <p align="center">
                                  Your organization’s partnership directly supports your Corporate
                                  Social <br></br> Responsibility (CSR) goals
                                </p> */}
                      
                                <Container className="paddingSubContainer programCardContainer mattersSectionVoice mt-30px">
                                  <Grid
                                    container
                                    spacing={2}
                                    mt={1}
                                    justifyContent="center"
                                    alignItems="center"
                                    display="flex"
                                  >
                                    {whyItMatters.map((text, index) => (
                                      <Grid
                                        size={{ xs: 12, md: 3, sm: 5 }}
                                        key={index}
                                        justifyContent="center"
                                        alignItems="center"
                                        display="flex"
                                      >
                                        <ProgramCard text={text} />
                                      </Grid>
                                    ))}
                                  </Grid>
                                </Container>
                              </Box>
                {/* What You Can Share */}
                               <Box className="schoolProgramMainSection">
                                  <Typography
                                         variant="h2"
                                         align="center"
                                         fontWeight={400}
                                         gutterBottom
                                         mt={5}
                                         className="subHeading mt-50px"
                                         sx={{ fontFamily: 'var(--heading-font)' }}
                                       >
                                        What You Can Share
                                       </Typography>
                                       <Container className="paddingSubContainer">
                                         <Grid container spacing={1} mt={5} mb={2} justifyContent="center">
                                           {howITWorks.map((text, index) => (
                                             <Grid size={{ xs: 12, md: 3, sm: 6 }} key={index}>
                                               <InfoCard text={text} 
                                                />
                                             </Grid>
                                           ))}
                                         </Grid>
                                       </Container>
                               </Box>  

                               {/* closing */}
                                <Box
                                                        sx={{
                                                          textAlign: "center",
                                                          borderRadius: 3,
                                                          marginBottom:'70px'
                                                        }}
                                                        mt={5}
                                                        className="TabPaddingContainer circleClosingBig circleClosingBigVoice">
                                                       {/* Title */}
                                                        <Typography
                                                          variant="h2"
                                                          fontWeight={400}
                                                          gutterBottom
                                                          className="subHeading"
                                                             sx={{ fontFamily: 'var(--heading-font)' }}
                                                        >
                                                        Closing
                                                        </Typography>
                                                       <Container className="paddingContainer mt-50px" mb={5}>
                                                          <Grid container spacing={0} justifyContent="center" mb={4}>
                                                            {circleCourses.map(({ text, colorClass }, index) => (
                                                              <Grid size={{ xs: 12, sm: 5, md: 3 }} key={index}>
                                                                <ConclusionCard text={text} colorClass={colorClass} />
                                                              </Grid>
                                                            ))}
                                                          </Grid>
                                                        </Container>
                                                 </Box>  
    </>
  )
}

export default Voices